const angular = require('angular');

const { ValidateProductService } = require('./validateproduct.service');

angular.module('wowApp.shop')
    .service('ValidateProductService', ValidateProductService);



// WEBPACK FOOTER //
// ./src/shop/validateproduct/index.js